import React from 'react';
import { Hero } from './components/Hero';
import { StatsAndProof, ExtendedTestimonials } from './components/ProofSections';
import { PainPoints } from './components/PainPoints';
import { ProductOffer } from './components/ProductOffer';
import { Pricing } from './components/Pricing';
import { CostSection, FooterAndProofPopup, GuaranteeAndFaq } from './components/ClosingSections';
export function App() {
  return <main className="min-h-screen w-full overflow-x-hidden bg-brand-ink text-white" data-id="element-0" data-mp="2rlp0msn6qhec">
      <Hero data-id="element-1" data-mp="2mmvlyww5wkcl" />
      <StatsAndProof data-id="element-2" data-mp="2mn5fgugf19n1" />
      <PainPoints data-id="element-3" data-mp="2mjpvpebsrcfa" />
      <ProductOffer data-id="element-4" data-mp="31aqd48uiugnk" />
      <Pricing showAnchor data-id="element-5" data-mp="31b8lu4ydencd" />
      <ExtendedTestimonials data-id="element-6" data-mp="31bi9vmzuukff" />
      <GuaranteeAndFaq data-id="element-7" data-mp="31ctf7r8y808n" />
      <CostSection data-id="element-8" data-mp="2wka20ve6b74d" />
      <Pricing data-id="element-9" data-mp="2wjqgl4pbe0ll" />
      <FooterAndProofPopup data-id="element-10" data-mp="2wj8dpp85co4p" />
    </main>;
}